export const admAllTypes = [
    { value: 'master', label: 'Master' },
    { value: 'receptionist', label: 'Recepcionista' },
];
